interface IAreaPhotosOffer {
    has_neighbourhood_gallery?: boolean;
}

export const getHasAreaPhotos = (offer: IAreaPhotosOffer): boolean => Boolean(offer.has_neighbourhood_gallery);
interface IAreaPhotosOffer {
    has_neighbourhood_gallery?: boolean;
}

export const getHasAreaPhotos = (offer: IAreaPhotosOffer): boolean => Boolean(offer.has_neighbourhood_gallery);
